import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Unit 9',
    id: 'WB3-U9-P61-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page61/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page61/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page61/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page61/E1/3.jpg', input: true, answer: "wearing gloves" },
        { url: 'img/FriendsPlus/Page61/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page61/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page61/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page61/E1/7.jpg', input: true, answer: "She's wearing boots." },
        { url: 'img/FriendsPlus/Page61/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page61/E1/9.jpg', input: true, answer: "He's wearing a shirt." },
        { url: 'img/FriendsPlus/Page61/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page61/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page61/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page61/E1/13.jpg', input: true, answer: "He's wearing a scarf." },
        { url: 'img/FriendsPlus/Page61/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page61/E1/15.jpg', input: true, answer: "She's wearing a skirt." },
        { url: 'img/FriendsPlus/Page61/E1/16.jpg' },
      ],



    ]
  },
  2: {
    unit: 'Unit 9',
    id: 'WB3-U9-P61-E2',
    audio: 'img/FriendsPlus/Page61/Audio/audio-e2-p61.mp3',
    video: '',
    component: D1,
    checkUppercase: true,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page61/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page61/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page61/Audio/tieude-e2-p61.mp3' },
        { url: 'img/FriendsPlus/Page61/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page61/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page61/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/6.jpg', input: true, answer: "I'm" },
        { url: 'img/FriendsPlus/Page61/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page61/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page61/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/10.jpg', input: true, answer: "dress" },
        { url: 'img/FriendsPlus/Page61/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page61/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page61/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/14.jpg', input: true, answer: "He's " },
        { url: 'img/FriendsPlus/Page61/E2/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page61/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/17.jpg', input: true, answer: "is" },
        { url: 'img/FriendsPlus/Page61/E2/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page61/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/20.jpg', input: true, answer: "wearing" },
        { url: 'img/FriendsPlus/Page61/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page61/E2/22.jpg', input: true, answer: "T-shirt" },
        { url: 'img/FriendsPlus/Page61/E2/23.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page61/E2/24.jpg' },
      ],
    ]
  },



}
export default json;